<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Részletes befizetések</span>
        </div>
        <detailed-payment-list />
      </el-card>
    </div>
  </div>
</template>

<script>
import DetailedPaymentList from '../../../components/reports/representativePayments/DetailedPaymentList';
import Sidebar from '../../../components/reports/representativePayments/Sidebar';

export default {
  components: {
    DetailedPaymentList,
    Sidebar,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    // this.loading = true;
    // await this.setConfig();
    // this.loading = false;
  },
  methods: {
    async setConfig() {
      let storages = this.$store.getters['storage/storages'];
      let users = this.$store.getters['user/users'];
      if (!storages.length) {
        await this.$store.dispatch('storage/fetchAll');
        storages = this.$store.getters['storage/storages'];
      }
      if(!users.length) {
        await this.$store.dispatch('user/fetchAll');
        users = this.$store.getters['user/users'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'select',
          options: [
            {
              label: 'Teljesített',
              status: 'done'
            },
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          options: storages,
          name: 'storage_id',
          label: 'Raktár',
          labelCallback: storage => storage && storage.name || '',
          valueKey: 'id',
        },
        {
          type: 'dateRange',
          name: 'delivery_date',
          label: 'Teljesítési időszak',
        },
        {
          type: 'select',
          options: users,
          name: 'creator_user_id',
          label: 'Rögzítette',
          labelCallback: user => user && `${user.last_name} ${user.first_name}` || '',
          valueKey: 'id',
        },
      ];
    },
  },
};
</script>
